'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThickCloseIcon = function ThickCloseIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', {
      d: 'M19.059 12.941L19.059 3.388C19.059 3.166 18.887 3 18.676 3L13.324 3 C13.118 3 12.941 3.174 12.941 3.388L12.941 12.941 3.388 12.941C3.166 12.941 3 13.113 3 13.324L3 18.676C3 18.882 3.174 19.059 3.388 19.059 L12.941 19.059 12.941 28.612C12.941 28.834 13.113 29 13.324 29L18.676 29 C18.882 29 19.059 28.826 19.059 28.612L19.059 19.059 28.612 19.059C28.834 19.059 29 18.887 29 18.676L29 13.324C29 13.118 28.826 12.941 28.612 12.941 L19.059 12.941Z',
      transform: 'translate(16.000000, 16.000000) rotate(-315.000000) translate(-16.000000, -16.000000) '
    })
  );
};

ThickCloseIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = ThickCloseIcon;